import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=da4b5aba&scoped=true&"
import script from "./ViewProfile.vue?vue&type=script&lang=js&"
export * from "./ViewProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4b5aba",
  null
  
)

export default component.exports